/**
 * Hằng số và tùy chọn liên quan đến BĐS (property).
 *
 * Bao gồm: loại giao dịch, trạng thái, publication status,
 * tùy chọn lọc/sắp xếp, và helper getTransactionLabel.
 */
import { TEXT } from '../languages';

/** Loại giao dịch: bán hoặc cho thuê */
export const TRANSACTION_TYPES = {
  sale: 'sale',
  rent: 'rent',
};

/** Loại tiếp cận: mặt tiền hoặc hẻm */
export const ACCESS_TYPES = {
  streetFront: 'street_front',
  alley: 'alley',
};

/** Trạng thái BĐS trên hệ thống (active/inactive/sold) */
export const PROPERTY_STATUSES = {
  active: 'active',
  inactive: 'inactive',
  sold: 'sold',
};

/** Trạng thái xuất bản (draft → pending → published...) */
export const PUBLICATION_STATUSES = {
  draft: 'draft',
  pending: 'pending',
  published: 'published',
  rejected: 'rejected',
  archived: 'archived',
};

/** Mức nội thất */
export const FURNISHED_STATUSES = {
  unfurnished: 'unfurnished',
  semiFurnished: 'semi_furnished',
  furnished: 'furnished',
};

/** Các kiểu sắp xếp danh sách BĐS */
export const PROPERTY_SORTS = {
  latest: 'latest',
  lowestPrice: 'lowest_price',
  highestPrice: 'highest_price',
  mostViewed: 'most_viewed',
};

/** Tùy chọn dropdown — lấy label từ i18n */
export const TRANSACTION_TYPE_OPTIONS = TEXT.property.options.transactionType;
export const PROPERTY_STATUS_OPTIONS = TEXT.property.options.status;
export const PUBLICATION_STATUS_OPTIONS = TEXT.property.options.publicationStatus;

/** Lọc publication status options theo thứ tự cho từng vai trò */
const getPublicationStatusOptionsByOrder = (orderedValues) =>
  orderedValues
    .map((statusValue) =>
      PUBLICATION_STATUS_OPTIONS.find(({ value }) => value === statusValue)
    )
    .filter(Boolean);

/** Super admin: draft, archived, published */
export const SUPERADMIN_PUBLICATION_STATUS_OPTIONS = getPublicationStatusOptionsByOrder([
    PUBLICATION_STATUSES.draft,
    PUBLICATION_STATUSES.archived,
    PUBLICATION_STATUSES.published,
]);

/** Admin thường: thêm pending (gửi duyệt) */
export const ADMIN_PUBLICATION_STATUS_OPTIONS = getPublicationStatusOptionsByOrder([
    PUBLICATION_STATUSES.draft,
    PUBLICATION_STATUSES.archived,
    PUBLICATION_STATUSES.pending,
    PUBLICATION_STATUSES.published,
]);

export const FURNISHED_STATUS_OPTIONS = TEXT.property.options.furnishedStatus;
export const PROPERTY_FEATURE_OPTIONS = TEXT.property.options.features;
export const PROPERTY_ROOM_SPEC_OPTIONS = TEXT.property.options.roomSpecs;

/** Trường lọc phòng (phòng ngủ, WC...) dùng trong PropertyFilters */
export const ROOM_SPEC_FILTER_FIELDS = PROPERTY_ROOM_SPEC_OPTIONS.map(({ fieldName, label }) => ({
  field: fieldName,
  label,
}));

/** Trường lọc tiện ích (hồ bơi, gara...) */
export const AMENITY_FILTER_FIELDS = PROPERTY_FEATURE_OPTIONS.map(({ fieldName, label }) => ({
  field: fieldName,
  label,
}));

export const PROPERTY_SORT_OPTIONS = TEXT.property.options.sort;
export const PRICE_MIN_OPTIONS = TEXT.property.options.priceMin;
export const PRICE_MAX_OPTIONS = TEXT.property.options.priceMax;
export const AREA_MIN_OPTIONS = TEXT.property.options.areaMin;
export const AREA_MAX_OPTIONS = TEXT.property.options.areaMax;
export const FRONTAGE_MIN_OPTIONS = TEXT.property.options.frontageMin;
export const PLOT_LENGTH_MIN_OPTIONS = TEXT.property.options.plotLengthMin;

export const ROOM_COUNT_OPTIONS = ['1', '2', '3', '4'];
export const BEDROOM_OPTIONS = ROOM_COUNT_OPTIONS;
export const BATHROOM_OPTIONS = ['1', '2', '3'];

/**
 * Lấy nhãn hiển thị loại giao dịch (bán/thuê).
 * @param {string} transactionType
 * @param {Object} [labels]
 * @returns {string}
 */
export const getTransactionLabel = (transactionType, labels = {}) => {
  if (transactionType === TRANSACTION_TYPES.rent) {
    return labels.rent || TEXT.property.transactionType.rent;
  }

  return labels.sale || TEXT.property.transactionType.sale;
};
